import React from "react";
import { withStyles, WithStyles } from "@material-ui/core";

import { styles } from "./FooterStyles";
import logofooter from "../../../assets/images/footer.png";


const Footer: React.FC<WithStyles<typeof styles>> = (props) => {
  const { classes } = props;
  return (
    <footer className={classes.root}>
      <div className={classes.horizontalLine}>
        <div className={classes.color1}></div>
        <div className={classes.color2}></div>
        <div className={classes.color3}></div>
      </div>
      <div className={classes.muni}>
        <img className={classes.logoImg}
          src={logofooter}
          alt="Logo de pie de página"
        />
      </div>
    </footer>
  );
};

export default withStyles(styles)(Footer) as React.ComponentType;
